import { Component, EventEmitter, Output } from '@angular/core';
import { InputComponent } from '@app/modules/change-requests/interfaces/input-component.class';

@Component({
    selector: 'compensation-type-input-component',
    template: `
        <div>
            <mat-form-field class="no-labels no-helpers">
                <mat-select
                    name="compensation_type"
                    placeholder="Compensation Type"
                    #department="ngModel"
                    [disabled]="disabled"
                    [(ngModel)]="value"
                    [aria-label]="ariaLabel"
                    (selectionChange)="valueUpdated.emit(value)"
                    [errorStateMatcher]="errorStateMatcher"
                >
                    <mat-option value="hour"> {{ 'employees.jobAndPay.hourly' | translate }} </mat-option>
                    <mat-option value="year"> {{ 'employees.jobAndPay.yearly' | translate }} </mat-option>
                </mat-select>
                <mat-error>{{ errorMessage }}</mat-error>
            </mat-form-field>
        </div>
    `,
})
export class CompensationTypeInputComponent extends InputComponent {
    @Output() valueUpdated: EventEmitter<string> = new EventEmitter<string>();
    value = '';
}
